<template>
    <div style="min-width: 2rem;">
        <el-dropdown>
            <span class="el-dropdown-link">
                <!-- {{ currentLanguageName || $t('切换语言') }} -->
                <!-- {{ $t('Language') }} -->
                <!-- <i class="el-icon-arrow-down el-icon--right"></i> -->
                <img :src="imgList[currentLanguageName] " alt="">
            </span>
            <el-dropdown-menu slot="dropdown">
                <div @click="command(item)" v-for="(item, index) of list" :key="item.key">
                    <el-dropdown-item>
                        <div style="display: flex;align-items: center;;">
                            <img :src="imgList[item.key]" alt="" style="height: 1rem;margin-right: 0.5rem;">

                            <div>
                                {{ item.name }}
                            </div>
                        </div>
                    </el-dropdown-item>
                </div>

            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>

<script>


export default {
    name: 'changeLanguage',
    data() {
        return {
            currentLanguageName: localStorage.getItem('change-language') || 'zh',
            list: [
                { key: 'zh', name: '中文' }, // 中文
                { key: 'EN', name: 'English' } // 英语
            ],
            imgList: {
                zh: require('../../public/image/中国国旗.png'),
                EN: require('../../public/image/美国国旗.png')
            }
        }
    },
    methods: {
        command(value) {
            // console.log(value)
            this.$i18n.locale = value.key
            localStorage.setItem('change-language', value.key)
            location.reload() //强制刷新
        }
    }
}
</script>

<style lang="scss" scoped>
.el-popper {
    z-index: 999999999 !important;
}

.el-dropdown-link {
    background-color: #f1f1f6;
    padding: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    margin-right: 0.5rem;

    img {
       
        height: 1rem;
    }
}

@media screen and (max-width: 992px) {
    .el-dropdown {
        height: 1rem !important;
        padding: 0;
        margin: 0;
        text-wrap: nowrap;

    }

}
</style>
